export default __webpack_public_path__ + "static/media/filter.a9e6854e.svg";